/**
 * Aus einem Fehler einen Satz machen (IS-32).
 *
 * **Der i18n-Key kommt aus der Antwort.** Das Backend schickt keinen Text,
 * sondern `key` und `params` (`app/api/errors.py`) — hier gibt es deshalb keine
 * zweite Zuordnungstabelle „Code → Satz", die mit der ersten auseinanderlaufen
 * könnte. Übersetzt wird, was ankommt.
 *
 * Fehlt der Key im Katalog, erscheint ein allgemeiner Satz statt des nackten
 * Keys. Die Kataloge werden in IS-35 vollständig gefüllt; bis dahin ist dieser
 * Rückfall der Unterschied zwischen „etwas ist schiefgegangen" und
 * `api.error.rate_limited` mitten auf dem Bildschirm.
 */
import { useTranslation } from 'react-i18next'

import { ApiFehler, NichtErreichbar } from './client'

export interface Fehleranzeige {
  /** Der Satz für den Menschen. */
  text: string
  /** Die Kennung für das Serverlog — leer, wenn es keine gibt. */
  requestId: string
}

export function useFehleranzeige(): (fehler: unknown) => Fehleranzeige {
  const { t } = useTranslation()

  return (fehler: unknown): Fehleranzeige => {
    if (fehler instanceof NichtErreichbar) {
      return { text: t('api.nicht_erreichbar'), requestId: '' }
    }
    if (fehler instanceof ApiFehler) {
      return {
        text: t(fehler.key, { ...fehler.params, defaultValue: t('api.error.unbekannt') }),
        // "-" setzt der Server, wenn er selbst keine hat; das ist keine Kennung,
        // die jemand nennen kann.
        requestId: fehler.requestId === '-' ? '' : fehler.requestId,
      }
    }
    return { text: t('api.error.unbekannt'), requestId: '' }
  }
}
